module.exports = __webpack_public_path__ + "img/t-left.260db0ff.png";